export default "__VITE_ASSET__BCwQO_un__"